import React, { Component } from 'react';
import { InitLayout } from '../../layouts';

class Logout extends Component {
  componentDidMount() {
    this.props.singleSignOff();
  }

  render() {
    return <InitLayout />;
  }
}

export default Logout;
